export const EDIT_TEAM_PLAYER = 'EDIT_TEAM_PLAYER'
export const EDIT_TEAM_NAME = 'EDIT_TEAM_NAME'
export const ADD_PLAYER_TO_TEAM = 'ADD_PLAYER_TO_TEAM'
export const REMOVE_PLAYER_FROM_TEAM = 'REMOVE_PLAYER_FROM_TEAM'

export const FETCH_REGISTRATIONS_SUCCESS = 'FETCH_REGISTRATIONS_SUCCESS'
export const FETCH_REGISTRATIONS_FAILURE = 'FETCH_REGISTRATIONS_FAILURE'
